import { Badge, Button, Dialog, useIsMobileScreen } from '@carbonify/ui';
import { BoltIcon } from '@heroicons/react/24/outline';
import { ReferralCampaign } from 'services/referrals/types';

import styles from './ReferralPopup.module.css';

interface Props extends ReferralCampaign {
  onClose: () => void;
  ctaUrl: string;
}

const DatoImgUrl = 'https://www.datocms-assets.com/196817/';

export default function ReferralPopup({
  bannerImageSrc,
  content,
  ctaBgColor,
  ctaButtonLabel,
  ctaUrl,
  logoSrc,
  onClose,
}: Props) {
  const isMobile = useIsMobileScreen();

  const placeholder = isMobile
    ? `${DatoImgUrl}1785437254-referral-bg-mobile.jpg`
    : `${DatoImgUrl}1785434617-referral-bg.jpg`;

  const cooperationLogo = logoSrc && (
    <div className={styles.cooperation}>
      <Badge
        variant="secondaryLight"
        compact
      >
        <BoltIcon className={styles.icon} />
        Exklusives Angebot
      </Badge>
      <p>in Kooperation mit</p>
      <img
        src={logoSrc}
        alt="Partner logo"
      />
    </div>
  );

  return (
    <Dialog
      open={!!content}
      onClose={onClose}
      className={styles.dialog}
      diableBackgroundClose
    >
      <div className={styles.container}>
        <div
          className={styles.image}
          style={{ backgroundImage: `url('${bannerImageSrc || placeholder}')` }}
        >
          {isMobile && cooperationLogo}
        </div>
        <div className={styles.content}>
          {!isMobile && cooperationLogo}
          <div
            dangerouslySetInnerHTML={{
              __html: content!,
            }}
          />
          <Button
            size="lg"
            style={{ backgroundColor: ctaBgColor, borderColor: ctaBgColor }}
            href={ctaUrl}
            onClick={onClose}
          >
            {ctaButtonLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
